import { Controller } from "@hotwired/stimulus"

// Botao "Voltar" que devolve o usuario a pagina de onde ele veio — o chat, a busca, um
// link externo — em vez de um destino fixo. O `href` do link segue sendo o fallback:
// funciona sem JS e e usado quando nao ha historico para voltar (aba nova aberta por
// target=_blank, link de e-mail, URL digitada direto).
export default class extends Controller {
  voltar(event) {
    // history.length == 1: aba nova, back() seria no-op. Nao previne o default, e o
    // navegador segue o href.
    if (window.history.length <= 1) return

    event.preventDefault()
    window.history.back()
  }
}
